function BioTile() {
  return (
    <section className="bentolio-card bentolio-area-about">
      <p className="body-text">
        <span className="nav-logo__peanut">Peanut Butter</span>
        <span className="nav-logo__jelly"> And Jelly</span> transforms your celebration
        dreams into unforgettable parties.
        From intimate gatherings to show-stopping events, we craft every detail with artistry
        and heart, so the day you&apos;ve imagined becomes the magic you&apos;ll remember forever.
      </p>
    </section>
  );
}

export default BioTile;
